/**
 * 数据错误异常类
 * Created by Qingger Corp.
 * User: jsspf
 * Date: 2017/11/16
 * Time: 15:45
 */
import BaseExceptionError from './BaseException';

/**
 * 基本数据错误异常类
 */
export class DataExceptionError extends BaseExceptionError {
  /**
   * @param {number} code
   * @param {string} message
   */
  // eslint-disable-next-line unicorn/custom-error-definition
  constructor(code: number, message: string) {
    super(code, message);
  }
}
